import { Link } from 'react-router-dom';
import SEOHead from './SEOHead';
import BrandLogo from './BrandLogo';

export default function TrialFrame({ title, subtitle, children, wide = false }) {
  return <>
    <SEOHead title={`${title} - Numerathum`} description="Tu prueba gratuita de Numerathum" noindex />
    <main className="min-h-screen bg-morado/5 px-4 py-12 flex items-center justify-center">
      <div className={`w-full ${wide ? 'max-w-6xl' : 'max-w-lg'}`}>
        <header className="text-center mb-8">
          <Link to="/" aria-label="Numerología Cotidiana, inicio" className="inline-block max-w-full mb-4">
            <BrandLogo className="w-64 sm:w-80" />
          </Link>
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-morado mb-3">Tu brújula del tiempo</p>
          <h1 className="text-3xl sm:text-4xl font-bold text-morado">{title}</h1>
          {subtitle && <p className="mt-3 text-gray-600 leading-relaxed">{subtitle}</p>}
        </header>
        {children}
      </div>
    </main>
  </>;
}
